import "core-js/modules/es.array.includes";
import "core-js/modules/es.string.includes";
import i18next from 'i18next';
import { useEffect } from 'react';
import { useLanguage } from './useLanguage';
export function useSetLanguage(_ref) {
  var lang = _ref.lang;

  var _useLanguage = useLanguage(),
      currentLang = _useLanguage.currentLang,
      allLangs = _useLanguage.allLangs;

  useEffect(function () {
    if (allLangs.includes(lang)) {
      i18next.changeLanguage(lang);
    }
  }, [lang, allLangs, currentLang]);
}